// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"61858cf4","167":"a65b8cd3","250":"5f5120e3","455":"a244b48e","644":"fdac536b","712":"19fbd376","931":"01086714","955":"ae7527c0","977":"b3671515"}[chunkId] + ".chunk.js";
};